export default {
  number: '+46707704662',
  display: '0707 - 70 46 62',
  currency: 'SEK',
  tracking: {},
};
